module.exports = __webpack_public_path__ + "img/2025_S.a847813d.png";